import React, {useEffect} from "react"
import everflowTracker from "@irati/ads/utils/everflow"
import adsService from "@irati/ads/services/ads"

interface Props {
  dealId: string
}

const AdsConvert: React.FC<Props> = ({dealId}) => {
  useEffect(() => {
    if (dealId) {
      everflowTracker.getForDealId(dealId).then((item) => {
        if (item?.tid) {
          // fire and forget convert + clear
          adsService.clickConvertForEverflow(item.tid)
          everflowTracker.clearForDealId(dealId)
        }
      })
    }
  }, [dealId])

  return null
}

export default AdsConvert
